import { render, staticRenderFns } from "./policyNews.vue?vue&type=template&id=69ff231f&scoped=true&"
import script from "./policyNews.vue?vue&type=script&lang=js&"
export * from "./policyNews.vue?vue&type=script&lang=js&"
import style0 from "./policyNews.vue?vue&type=style&index=0&id=69ff231f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ff231f",
  null
  
)

export default component.exports